import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import MainHeader from "./header/MainHeader";
import MainSidebar from "./sidebar/MainSidebar";
import { PrivateRoutes, PublicRoutes } from "../../config/routes";
import { Box, ModalOverlay } from "@chakra-ui/react";
import DeleteAccountRequestModal from "../DeleteAccountRequestModal";
import DeleteModal from "../DeleteModal";
import { globalState } from "../../../state";
import "#frontend/components/modals/longtime/index.solid";
import "#frontend/components/modals/recoveryPin.solid";

const MainLayout: React.FC = () => {
  const [showDeleteAccountRequestModal, setShowDeleteAccountRequestModal] =
    useState<boolean>(false);
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const navigate = useNavigate();

  const [isSidebarCollapsed, setSidebarCollapsed] = useState<boolean>(false);

  const closeDeleteAccountRequestModal = () => {
    setShowDeleteAccountRequestModal(false);
    setShowDeleteModal(true);
  };
  return (
    <>
      <MainHeader />
      <MainSidebar
        isSidebarCollapsed={isSidebarCollapsed}
        setSidebarCollapsed={setSidebarCollapsed}
      />
      <Box
        width={{
          base: "100%",
          md: isSidebarCollapsed ? "calc(100% - 84px)" : "calc(100% - 300px)",
        }}
        marginLeft={{
          base: "0px",
          md: isSidebarCollapsed ? "84px" : "300px",
        }}
        height="100%"
        backgroundColor="brand.appBackground"
        padding="100px 20px 20px 20px"
        as="main"
        overflowY="auto"
        transition="all 0.5s"
      >
        <Box maxWidth="970px" margin="0 auto">
          <Outlet />
        </Box>
      </Box>

      <DeleteAccountRequestModal
        onClose={closeDeleteAccountRequestModal}
        isOpen={showDeleteAccountRequestModal}
      >
        <ModalOverlay />
      </DeleteAccountRequestModal>
      <DeleteModal
        isOpen={showDeleteModal}
        onClose={async () => {
          await globalState.client.logout();
          navigate(PublicRoutes.LOGIN);
        }}
        deletePath="Did not accept PP or TOU"
      >
        <ModalOverlay />
      </DeleteModal>
      <long-time-no-see-modal />
      <recovery-pin-update-modal />
    </>
  );
};

export default MainLayout;
